import { createAsyncThunk } from '@reduxjs/toolkit';
import { siteService, userService } from 'services';
import {
  GetListAgentError,
  GetListAgentRequest,
  GetListAgentResponse,
  GetMapError,
  GetMapRequest,
  GetMapResponse,
  GetUserSitesError,
  GetUserSitesRequest,
  GetUserSitesResponse,
  ThunkAPI,
} from 'types';

export const getListSite = createAsyncThunk<
  GetListAgentResponse,
  GetListAgentRequest,
  ThunkAPI<GetListAgentError>
>('siteList/thunk/getListAgent', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getListAgent(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getUserSiteCharge = createAsyncThunk<
  GetUserSitesResponse,
  GetUserSitesRequest,
  ThunkAPI<GetUserSitesError>
>('siteList/thunk/user/sites_charge', async (params, { rejectWithValue }) => {
  try {
    const { data } = await userService.getUserSites(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getUserSiteAgent = createAsyncThunk<
  GetUserSitesResponse,
  GetUserSitesRequest,
  ThunkAPI<GetUserSitesError>
>('siteList/thunk/user/sites_agent', async (params, { rejectWithValue }) => {
  try {
    const { data } = await userService.getUserSites(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getMapSite = createAsyncThunk<GetMapResponse, GetMapRequest, ThunkAPI<GetMapError>>(
  '/thunk/map/sites',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await userService.getMap(params);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || { message: 'エラーが発生しました。' });
    }
  }
);
